import { createPromiseCache } from "./promise-cache";
import { normalizeResponseArray } from "./response-array";

interface IComponentAutocompleteItem {
  id: number;
}

interface IComponentPointAutocompleteItem {
  id: number | string;
}

interface IMultiAnalysisComponentApi {
  fetchJson: (args: { url: string; method: "GET"; data: Record<string, unknown> }) => Promise<unknown>;
}

const pointToComponentCache = createPromiseCache<Map<number, number>>();

export const loadPointToComponentMap = (
  api: IMultiAnalysisComponentApi,
  trainId: number,
): Promise<Map<number, number>> =>
  pointToComponentCache.getOrCreate(String(trainId), async () => {
    const components = normalizeResponseArray(
      (await api.fetchJson({
        url: "/component/autocomplete",
        method: "GET",
        data: { idTrain: trainId },
      })) as IComponentAutocompleteItem[] | null | undefined,
    );

    const map = new Map<number, number>();

    await Promise.all(
      components.map(async component => {
        const componentId = Number(component.id);

        if (!Number.isFinite(componentId) || componentId <= 0) {
          return;
        }

        const points = normalizeResponseArray(
          (await api.fetchJson({
            url: "/component/point/autocomplete",
            method: "GET",
            data: { idTrainComponent: componentId },
          })) as IComponentPointAutocompleteItem[] | null | undefined,
        );

        for (const point of points) {
          const pointId = Number(point.id);

          if (Number.isFinite(pointId) && pointId > 0) {
            map.set(pointId, componentId);
          }
        }
      }),
    );

    return map;
  });

export const resolveTrainComponentIdForPoint = async (
  api: IMultiAnalysisComponentApi,
  trainId: number,
  pointId: number,
): Promise<number | null> => {
  const map = await loadPointToComponentMap(api, trainId);

  return map.get(pointId) ?? null;
};
